"use strict";

var icons = require('@soluto-design/icons/dist/icons-specific');
var defaultIcons = require('./icons.js');
Object.keys(icons).filter(function (icon) {
  return !!icons[icon];
}).forEach(function (icon) {
  defaultIcons[icon] = icons[icon];
});
module.exports = defaultIcons;